import { useAuth0 } from '@auth0/auth0-react';
import { Alert, AlertDescription, AlertTitle, Button } from '@sunstone/ui';
import { AlertCircleIcon, Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

/**
 * Callback page that Auth0 redirects to after authentication.
 * This page should be registered as a callback URL in Auth0.
 */
export function CallbackPage() {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/dashboard', { replace: true });
      } else if (error) {
        navigate('/', { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="w-full max-w-md space-y-4 text-center">
          <Alert variant="destructive" className="text-left">
            <AlertCircleIcon />
            <AlertTitle>Authentication Error</AlertTitle>
            <AlertDescription>{error?.message}</AlertDescription>
          </Alert>
          <Button onClick={() => navigate('/', { replace: true })}>Return Home</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="mx-auto mb-4 h-10 w-10 animate-spin text-primary" />
        <h2 className="mb-1 text-xl font-semibold text-foreground">Completing Sign In...</h2>
        <p className="text-sm text-muted-foreground">Please wait while we log you in</p>
      </div>
    </div>
  );
}
